<template>
  <vuestic-widget header-text="Reportes">
    <ul>
<!--      <li>-->
<!--        <router-link :to="{name: 'reporteCompras'}">Reporte Compras Por Proveedor</router-link>-->
<!--      </li>-->
      <li>
        <router-link :to="{name: 'reportePreIngreso'}">Reporte Pre Ingreso</router-link>
      </li>
      <li>
        <router-link :to="{name: 'reporteDocumento'}">Reporte Documento</router-link>
      </li>
      <li>
        <router-link :to="{name: 'reporteDocumentPdf'}">Reporte Documento PDF</router-link>
      </li>
    </ul>
    <router-view></router-view>
  </vuestic-widget>
</template>

<script>
  import VuesticWidget from "../../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget";

  export default {
    name: "reporteRecepcionKibana",
    components: {VuesticWidget}
  }
</script>

<style scoped>

</style>
